import { ref } from "vue";

export const qrCodePopup = ref({
  isVisible: false,

  showQrCode() {
    qrCodePopup.value.isVisible = true;
  },

  hideQrCode() {
    qrCodePopup.value.isVisible = false;
  },
});
